export const language: any = {
  main: "Hauptmenü",
  ingredients: "Zutaten",
  ai_chef: "KI-Koch",
  favorites: "Favoriten",
  menu: "Menü",
  get_start: "Loslegen",
  title_first_1: "KI schlägt Rezepte nach Alter vor",
  title_second_1: "Perfekt organisiert vom Menü bis zum Rezept",
  content_1: "Keine Sorgen mehr über tägliche Menüs und Kalorien. Ab jetzt bekommst du Vorschläge von Hey! Cooker",
  title_first_2: "Heute ist es kalt, du hattest einen anstrengenden Tag.",
  title_second_2: "Wie wäre es mit einem deftigen Armeeeintopf nach der Arbeit?",
  content_2: "Finde das Dosenfleisch und die Instantnudeln in deinem Kühlschrank und bereite ein einfaches Abendessen zu!",
  my_food_ingredients: "Weißt du nicht, was du kochen sollst?",
  btn_add_photo: "Wähle ein Bild oder mache ein Foto",
  my_food_reason: "Wähle die Zutaten, die du hast",
  btn_get_cooking: "KI-Rezeptvorschläge erhalten",
  enriching_title: "Bereichere Körper und Geist",
  enriching: "Eine Sammlung von Rezepten",
  photo_registration_title: "Mache ein Foto oder lade einen Beleg hoch<br/>und erhalte Menüvorschläge!",
  photo_registration_content: "Erlebe die Freude am Kochen, indem du Zutaten erkennst<br/> und Rezepte mit KI analysierst!",
  food_suggestions_title: "Weißt du nicht, was du essen sollst?",
  food_suggestions_sub_title: "Themenbasierte Gerichte",
  our_interests_title: "Erstelle das perfekte Menü für dich und deine Familie!",
  our_interests_sub_title: "Wähle basierend auf Alter und Geschlecht.",
  favorite_title: "Vielfältige Kochbücher",
  weather_title: "Gerichte, die perfekt für kaltes Wetter sind",
  video_title: "Entdecke lebendige Videos",
  tag: {
    close: "Schließen",
    open: "Erweitern"
  },
  no_data: "Keine Daten",
  update_version_submit: "Jetzt aktualisieren",
  update_version_title: "Es gibt eine neue Version der App.",
  update_version_content: "Für die beste Nutzungserfahrung aktualisiere bitte auf die neueste Version der App.",
  close_btn: "Schließen",
  not_video_id: "Video existiert nicht",
  favorite_login: "Melde dich an oder registriere dich, um deine Lieblingsrezepte zu speichern.",
  favorite_section_title: "Vergiss nicht, deine gespeicherten Rezepte zu überprüfen",
  favorite_section_description: "Meine Lieblingsrezepte",
  discover: "Entdecken",
  my_cooker: "Meine Küche",
  view_recipe: "Rezepte mit ausgewählten Zutaten ansehen",
  my_ingredient: "Meine Zutaten",
  add_ingredient: "Meine Zutaten hinzufügen",
  video_section_title: "Erkunde und erlebe durch Videos",
  video_section_description: "Empfohlene Kochvideos",
  age_10: "U10",
  age_10_to_20: "10-20 Jahre",
  age_20_to_30: "20-30 Jahre",
  age_30_to_40: "30-40 Jahre",
  age_40_to_50: "40-50 Jahre",
  age_more_50: "50+",
  suggest_section_title: "Hey! Cooker hilft dir bei der Auswahl",
  suggest_section_description: "Welche Themen interessieren dich?",
  weather_title1: "Heutige Vorschläge",
  weather_title2: "Was essen an einem regnerischen, kalten Tag?",
  tasteSuggestion1: "Verwöhne deine Geschmacksknospen",
  tasteSuggestion2: "Aromen, die perfekt zu dir passen",
  tasteTitle1: "Würzig <br />und verlockend",
  tasteTitle2: "Frisch und <br />leicht",
  tasteTitle3: "Säuerlich <br />und aufregend",
  tasteTitle4: "Aromatisch - <br />süß",
  tasteTitle5: "Harmonisch <br />und fesselnd",
  tasteDescription1: "#Pfanne #Grill #Regentag",
  tasteDescription2: "#Frisch #Ballaststoffe #Diät",
  tasteDescription3: "#Sauer #Süß #Aufregend",
  tasteDescription4: "#Einzigartig #Gewürze #Magie",
  tasteDescription5: "#Geschmack #Nährstoffe #Genuss",
  suggest_item_title1: "Einfache Gerichte",
  suggest_item_description1: "Einfache Frühstücks- und Mittagsrezepte",
  suggest_item_title2: "Diät",
  suggest_item_description2: "Kohlenhydratarm<br/>Absolut lecker",
  suggest_item_title3: "Jahresendgerichte",
  suggest_item_description3: "Gerichte für die Hausparty",
  suggest_item_title4: "Gesunde Ernährung",
  suggest_item_description4: "Für einen gesunden Körper und Geist<br/>Treffe bessere Entscheidungen",
  suggest_item_title5: "Einfache Snacks",
  suggest_item_description5: "Snacks für das gemütliche Feierabendbier",
  history: "Bildanalyse-Verlauf",
  community: {
    sub_title: "Kochen mit allen",
    title: "Hey! Cooker Community-Suche",
    trending: "Trend",
    follow: "Folge ich",
    video: "Video",
    discover: "Entdecken",
    no_data: "Keine neuen Updates in der Hey! Cooker-Community",
    discover_post: "Weitere Beiträge in der Community durchsuchen"
  },
  user_suggest_title1: "Heutige Vorschläge",
  user_suggest_title2: "Zufällige Rezeptvorschläge"
}
